<style>
  /* Branded Material auth card (inherits color + type from the TRD Material theme) */
  .trd-auth-shell{ min-height:78vh; display:flex; align-items:center; justify-content:center; padding:40px 16px; }
  .trd-auth-card{ width:404px; max-width:100%; padding:34px 32px 26px; border-radius:14px; text-align:left; }
  .trd-auth-logo{ width:64px; height:auto; display:block; margin-bottom:18px; border-radius:4px; }
  .trd-auth-title{ font:600 24px "Open Sans",sans-serif; margin:0 0 4px; color:rgba(0,0,0,.87); }
  .trd-auth-sub{ font:14px "Open Sans",sans-serif; color:rgba(0,0,0,.6); margin:0 0 20px; }
  .trd-auth-form{ display:flex; flex-direction:column; }
  .trd-ff{ width:100%; }
  .trd-forgot{ display:flex; justify-content:flex-end; margin:-8px 0 12px; }
  .trd-auth-btn{ width:100%; height:44px; font-weight:600; letter-spacing:.02em; }
  .trd-auth-foot{ text-align:center; font:14px "Open Sans",sans-serif; color:rgba(0,0,0,.6); margin:14px 0 0; }
  .trd-otp-btn{ width:100%; margin:0 0 10px; }
  .trd-or{ display:flex; align-items:center; text-align:center; color:rgba(0,0,0,.4); font:12px "Open Sans",sans-serif; margin:16px 0 12px; }
  .trd-or::before, .trd-or::after{ content:""; flex:1; border-bottom:1px solid #e0e0e0; }
  .trd-or span{ padding:0 12px; }
  .trd-google-wrap{ display:flex; justify-content:center; }
</style>

<div class="trd-auth-shell">

  @if (personRe) {
    <mat-card class="trd-auth-card">
      <img class="trd-auth-logo" src="../../assets/new-home-page/images/logo.jpg" alt="TheRightDoctors"/>
      <h1 class="trd-auth-title">Sign in</h1>
      <p class="trd-auth-sub">Welcome back to TheRightDoctors.</p>
      <form role="form" (ngSubmit)="login()" #ff="ngForm" novalidate class="trd-auth-form">
        <mat-form-field appearance="outline" class="trd-ff">
          <mat-label>Email</mat-label>
          <input matInput type="email" name="user_id" [(ngModel)]="model2.user_id" #user_id="ngModel" required>
        </mat-form-field>
        <mat-form-field appearance="outline" class="trd-ff">
          <mat-label>Password</mat-label>
          <input matInput [type]="hidePassword ? 'password' : 'text'" name="password" [(ngModel)]="model2.password" #password="ngModel" required>
          <button mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility()" [attr.aria-label]="'Toggle password visibility'">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>
        <div class="trd-forgot"><a mat-button [routerLink]="['/forgot-password']">Forgot password?</a></div>
        <button mat-flat-button type="submit" class="trd-auth-btn">Log in</button>
      </form>
      <div class="trd-or"><span>or</span></div>
      <div class="trd-google-wrap"><div id="googleBtn"></div></div>
      <p class="trd-auth-foot">New to TheRightDoctors? <a mat-button (click)="switch_to_reg_page()" style="cursor:pointer">Create account</a></p>
    </mat-card>
  }

  @if (loginpe) {
    <mat-card class="trd-auth-card">
      <img class="trd-auth-logo" src="../../assets/new-home-page/images/logo.jpg" alt="TheRightDoctors"/>
      <h1 class="trd-auth-title">Create your account</h1>
      <p class="trd-auth-sub">Join TheRightDoctors to save and personalise your experience.</p>
      <form role="form" (ngSubmit)="register()" #ff="ngForm" class="trd-auth-form">
        <mat-form-field appearance="outline" class="trd-ff">
          <mat-label>First Name</mat-label>
          <input matInput type="text" name="firstname" [(ngModel)]="model2.firstname" #firstname="ngModel" required>
        </mat-form-field>
        <mat-form-field appearance="outline" class="trd-ff">
          <mat-label>Last Name</mat-label>
          <input matInput type="text" name="lastname" [(ngModel)]="model2.lastname" #lastname="ngModel" required>
        </mat-form-field>
        <mat-form-field appearance="outline" class="trd-ff">
          <mat-label>Email</mat-label>
          <input matInput type="email" name="email" [(ngModel)]="model2.email" #email="ngModel" required>
        </mat-form-field>
        <mat-form-field appearance="outline" class="trd-ff">
          <mat-label>Password</mat-label>
          <input matInput [type]="hidePassword ? 'password' : 'text'" name="password" [(ngModel)]="model2.password" #password="ngModel" required>
          <button mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility()" [attr.aria-label]="'Toggle password visibility'">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field appearance="outline" class="trd-ff">
          <mat-label>Confirm Password</mat-label>
          <input matInput [type]="hideConfirmPassword ? 'password' : 'text'" name="confirmpassword" [(ngModel)]="model2.confirmpassword" #confirmpassword="ngModel" required>
          <button mat-icon-button matSuffix type="button" (click)="toggleConfirmPasswordVisibility()" [attr.aria-label]="'Toggle password visibility'">
            <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field appearance="outline" class="trd-ff">
          <mat-label>Select Country Code</mat-label>
          <mat-select name="country_code" [(value)]="selected" #country_code="ngModel"
            (selectionChange)="function(selected)" [(ngModel)]="model2.country_code" required>
            <mat-option value="+91">India +91</mat-option>
            <mat-option value="+1">United States +1</mat-option>
            <mat-option value="+44">United Kingdom +44</mat-option>
            <mat-option value="+971">United Arab Emirates +971</mat-option>
            <mat-option value="+92">Pakistan +92</mat-option>
            <mat-option value="+977">Nepal +977</mat-option>
          </mat-select>
          @if (country_code.invalid) {
            <mat-error>You must make a selection</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="trd-ff">
          <mat-label>Mobile No.</mat-label>
          <input matInput type="number" name="mobile" id="mobile" [(ngModel)]="model2.mobile" #mobile="ngModel" required>
        </mat-form-field>

        @if (verification_code) {
          <mat-form-field appearance="outline" class="trd-ff">
            <mat-label>Enter your code</mat-label>
            <input matInput name="token" [(ngModel)]="model3.token" required>
          </mat-form-field>
          <button mat-stroked-button class="trd-otp-btn" type="button" (click)="verify_code()">Verify Code</button>
        }

        @if (!m_verify) {
          <div id="trd-turnstile" class="trd-turnstile" style="margin:0 0 10px"></div>
          <button mat-stroked-button class="trd-otp-btn" type="button" (click)="phone_btn_onclick()">Verify mobile number (Send / Resend OTP)</button>
        }

        <button mat-flat-button class="trd-auth-btn" type="submit">Create account</button>
      </form>
      <div class="trd-or"><span>or</span></div>
      <div class="trd-google-wrap"><div id="googleBtn"></div></div>
      <p class="trd-auth-foot">Already have an account? <a mat-button (click)="switch_to_login_page()" style="cursor:pointer">Sign in</a></p>
    </mat-card>
  }

</div>
